import CAApi from './_caApi';
import httpClient from '@/apis/base/httpclient';

class CAFundInventoryAPI extends CAApi {
  constructor() {
    super();
  }
  controllerName = 'CAFundInventorys';

  /**
  * Lấy số dư theo sổ kế toán tiền mặt 
  * @param {*} payload
  * @returns
  * NNLINH 15.08.2023
  */
   async getSurplusAccountAmount(payload) {
     let apiUrl = this.getAPIUrl();
 
     let request = {
       url: apiUrl + '/SurplusAccountAmount',
       data: payload,
     };
 
     return await httpClient.postAsync(request);
   }

  /**
  * Hàm sinh chứng từ xử lý chênh lệch
  * @param {*} payload
  * @returns
  * NNLINH 15.08.2023
  */
   async getDataGenerate(payload) {
     let apiUrl = this.getAPIUrl();
 
     let request = {
       url: apiUrl + '/DataGenerate',
       data: payload,
     };
 
     return await httpClient.postAsync(request);
   }
}
  
export default new CAFundInventoryAPI();
